/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect, useState } from "react";
import { HeaderComp } from "../../../widgets/landing-page-widget/components/Header";
import { Header, TriggerForm } from "../components";
import { useSMTrigger, useSMTriggerCyclone } from "../machines";
import { StateOSD } from "@vlinder-web/state-osd-v2-widget-react";
import { TriggerPageService } from "../../../services";
import { VApplication } from "../../../application";
import { NotificationModal } from "@vlinder-web/notification-modal-v2-widget-react";
import { Paginate } from "@vlinder-web/paginate-widget-react";
import { SearchFilter } from "../../../widgets/filter-widget-react";
import { Footer } from "../../../widgets/landing-page-widget/components/Footer";
import { Container } from "react-bootstrap";

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.TriggerPageService") as TriggerPageService;
};

export const ContainerComm = (props: any) => {
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  // const [refreshPagination, setReFreshPagination] = useState(new Date());
  const srv = getSrv();

  // useEffect(() => {
  //   srv?.resetCriteria();
  // }, []);

  const { triggerPageMachine, triggerPageSend, triggerPageState } =
    useSMTrigger({});

    const { triggerCycloneMachine, triggerCycloneSend, triggerCycloneState } =
    useSMTriggerCyclone({});


  // const onRevokeClick = (ids: any) => {
  //   revokeCredentialSend("START", {
  //     payload: ids,
  //   });
  // };

  // const onRefresh = () => {
  //   triggerPageSend("TRIGGER_REFRESH", {});
  //   setReFreshPagination(new Date());
  // };

  // const onClearFilter = () => {
  //   srv?.resetCriteria();
  //   Array.from(document.querySelectorAll("input")).forEach(
  //     input => (input.value = "")
  //   );
  //   holdersPageSend("TRIGGER_REFRESH", {});
  // };

  const _renderNotification = () => {
    if (triggerCycloneState?.matches("TRIGGER_CYCLONE_SUCCESS")) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.triggerSuccess || {})}
          // onAcknowledgement={onRefresh}
          // onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const onTriggerSubmit = (
    // eventId: string,
    // exposure: string,
    // stormName: string,
    // vmin: number,
    // vmax: number,
    // date: Date,
    // country: string,
    // category: string,
    // status: string,
    // reason: string,
    // payoutEstimate: string
    data: any
  ) => {
    console.log("The data from the form is : ", data);

    const payload: any = {};
    if (data?.eventId) {
      payload.eventId = data?.eventId;
    }
    if (data?.exposure) {
      payload.exposure = data?.exposure;
    }
    if (data?.stormName) {
      payload.stormName = data?.stormName;
    }
    if (data?.vmin) {
      payload.vmin = data?.vmin;
    }
    if (data?.vmax) {
      payload.vmax = data?.vmax;
    }
    if (data?.date) {
      payload.date = data?.date;
    }
    if (data?.country) {
      payload.country = data?.country;
    }
    if (data?.category) {
      payload.category = data?.category;
    }
    if (data?.status) {
      payload.status = data?.status;
    }
    if (data?.reason) {
      payload.reason = data?.reason;
    }
    if (data?.payoutEstimate) {
      payload.payoutEstimate = data?.payoutEstimate;
    }

    console.log("The data in the payload is : ", payload);
    triggerCycloneSend("START", {
      event: payload,
    });
  };

  const _renderPage = () => {
    if (triggerPageState?.matches("GET_PAGE_CONTENT")) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.retrieveCredentials || {})}
        />
      );
    }

    if (triggerCycloneState?.matches("TRIGGER_CYCLONE")) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.triggerSubmit || {})}
        />
      );
    }

    if (triggerPageState?.matches("RENDER_PAGE")) {
      console.log("Trigger page config ", staticPageContentConfig?.triggerConfig);
      return (
        <>
          {triggerPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(staticPageContentConfig?.loading?.loadingTrigger || {})}
            />
          ) : (
            // <UsersListComp
            //   {...(triggerPageState?.event?.data?.value || {})}
            //   onViewDetailClick={props?.onViewDetailClick}
            //   onRevokeClick={onRevokeClick}
            //   onRowClick={props?.onViewDetailClick}
            // />

            <TriggerForm
              triggerFields={
                staticPageContentConfig?.triggerConfig?.FIELDS
              }
              triggerLayout={
                staticPageContentConfig?.triggerConfig?.layout
              }
              validatorConfig={
                staticPageContentConfig?.triggerConfig?.validatorConfig
              }
              onTriggerSubmit={onTriggerSubmit}
            />
          )}
        </>
      );
    }
    return null;
  };

  const _renderErrorModals = () => {
    if (triggerPageState?.matches("RENDER_PAGE_ERROR")) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.triggerPageError || {})}
          // onAcknowledgement={onRefresh}
          // onDeny={onRefresh}
        />
      );
    }
    if (triggerCycloneState?.matches("TRIGGER_CYCLONE_FAILED")) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.triggerSubmitError || {})}
          // onAcknowledgement={onRefresh}
          // onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Container>
            <Header
              {...(staticPageContentConfig?.header || {})}
              // onRefreshClick={onRefresh}
            />
          </Container>
        </>
      );
    }
    return null;
  };

  const _renderFooter = () => {
    if (staticPageContentConfig?.footer) {
      return (
        <>
          <Footer
            {...(staticPageContentConfig?.footer || {})}
            // onRefreshClick={onRefresh}
          />
        </>
      );
    }
    return null;
  };

  const _renderTopHeader = () => {
    if (staticPageContentConfig?.topHeader) {
      return (
        <>
          <HeaderComp
            {...(staticPageContentConfig?.topHeader || {})}
            // onRefreshClick={onRefresh}
          />
        </>
      );
    }
    return null;
  };

  return (
    <>
      {_renderTopHeader()}
      {_renderHeader()}
      {_renderPage()}
      {_renderErrorModals()}
      {_renderNotification()}
      {_renderFooter()}
    </>
  );
};
